// extracted by mini-css-extract-plugin
export default {"headingText":"responseBox_headingText__gHzcj","copyButton":"responseBox_copyButton__xlhEf","slideTransition":"responseBox_slideTransition__1X051"};